import { Box, Grid } from '@mui/material';
import { useLpkRunContext } from './lpk-run-context';
import { Choice } from '../../../../components/Choice';
import { NumericInput } from './form-controls';
import { CropSelector } from './CropSelector';

export function YieldQuickFill() {
  const {
    yieldLoaded,
    yieldQuickFill,
    setYieldQuickFill,
    yieldCropGoals,
    setYieldCropGoals,
  } = useLpkRunContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {buildSelectors()}
      {buildCropGoals()}
    </Box>
  );

  function buildSelectors() {
    return (
      <Box name="Rx Type" sx={{ mt: 2 }}>
        <Grid
          component="ul"
          sx={{
            listStyle: 'none',
            p: 0,
            '& .MuiFormControlLabel-label': { textTransform: 'uppercase' },
          }}
          container
          columnSpacing={{ xs: 2, sm: 3 }}
          rowSpacing={2}
        >
          <Grid item xs={12} sm={6}>
            <Choice
              small
              disabled={!yieldLoaded}
              option={{
                label: 'Use last 2 years of yield',
                value: 'last2yield',
              }}
              onSelect={(selection) => setYieldQuickFill(selection)}
              isSelected={yieldQuickFill === 'last2yield'}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Choice
              small
              option={{ label: 'Use yield goal', value: 'cropGoals' }}
              onSelect={(selection) => setYieldQuickFill(selection)}
              isSelected={yieldQuickFill === 'cropGoals'}
            />
          </Grid>
        </Grid>
      </Box>
    );
  }

  function buildCropGoals() {
    if (yieldQuickFill !== 'cropGoals') return null;

    return (
      <Grid container spacing={{ xs: 2, sm: 3 }}>
        <Grid item xs={6}>
          {buildCropGoalSelector(1)}
        </Grid>
        <Grid item xs={6}>
          {buildCropGoalSelector(2)}
        </Grid>
      </Grid>
    );
  }

  function buildCropGoalSelector(index) {
    function updateCropGoals(goal) {
      const newCropGoals = [...yieldCropGoals];
      Object.assign(newCropGoals[index - 1], goal);
      setYieldCropGoals(newCropGoals);
    }

    return (
      <>
        <CropSelector
          required
          sx={{ width: '100%' }}
          label={`Select Crop ${index}`}
          value={yieldCropGoals[index - 1].crop}
          onChange={(e) => updateCropGoals({ crop: e.target.value })}
        />
        <NumericInput
          required
          label={`Yield Goal ${index}`}
          min={0}
          ignoreNonNumericInput
          value={yieldCropGoals[index - 1].value}
          onChange={(e) => updateCropGoals({ value: e.target.value })}
        />
      </>
    );
  }
}
